export const white = '#ffffff';
export const black = '#2A2A2A';

export const greyLight = '#FAFAFA';
export const grey = '#F6F6F6';
export const greyDark = '#E4E4E4';
export const greyDarker = '#C9C9C9';
export const greyDarkest = '#949494';
export const greyPlaceholder = '#919191';

export const blueLight = '#E5F6FF';
export const blue = '#0075BF';
export const blueDark = '#005E94';
export const blueDarker = '#003D61';

export const indigo = '#01416F';
export const turquoise = '#3AB5E8';
export const green = '#00B900';

export const orangeLight = '#F5822B';
export const orange = '#FF6600';
export const orangeDark = '#BE5709';

export const errorRed = '#D0021B';

//lindab group colors below
export const lgDarkBlue = '#00426e';
export const lgBlueGray = '#4d6b7b';
export const lgGreenGray = '#6b7a7c';
export const lgGreen = '#4c7468';
export const lgYellow = '#d7a72f';
export const lgBrown = '#887c74';
export const lgDarkGray = '#4d555b';
export const lgBeige = '#dad3c9';
export const lgLightBrown = '#eae1d9';
export const lgLightGray = '#eae8e3';
export const lgLightGrayBlue = '#eaecef';
